<template>
    <span v-bind="$attrs">
        <span v-if="result.us_citizen || !meet.exclude_foreign_athletes" class="font-weight-bold text-h6">
            <template v-if="ordinal">
                {{ result.ordinalRank(`${round}_placement`) }}
            </template>
            <template v-else>
                {{ placement }}
            </template>
            <template v-if="result[`${round}_placement`]?.includes('T')">
                <v-icon small class="mt-n1" @click="$emit('more-info')">info</v-icon>
            </template>

            <span v-if="showQual" class="">{{ showQual }}</span>
        </span>
        <span v-else class="font-weight-bold text-h6">
            <v-tooltip top>
                <template #activator="{ on }">
                    <span v-on="on">{{ placement }}</span>
                </template>
                Foreign athletes are ranked, but not included in the official results.
            </v-tooltip>
        </span>
    </span>
</template>

<script>
import Result from '@/Models/Result.js';
import Meet from '@/Models/Meet.js';

export default {
    name: 'ResultPlacement',

    props: {
        result: {
            type: Result,
            required: true,
        },

        meet: {
            type: Meet,
            required: true,
        },

        round: {
            type: String,
            required: true,
        },

        ordinal: {
            type: Boolean,
            default: false,
        },

        showQual: {
            type: String,
            default: '',
        },
    },

    computed: {
        placement() {
            return this.result[`${this.round}_placement`];
        },
    },
};
</script>
